<template>
  <div class="multi-jump-wrapper" v-stat.brow.click="biContent" @click="handleClick">
    <!-- 默认展示插槽 -->
    <slot v-if="$slots.default" />
    <!-- 否则，如果有图片地址，则展示图片 -->
    <img v-else-if="imgUrl" class="jump-img" :src="imgUrl" role="button" :aria-label="imgAlt" />
    <!-- 小程序 -->
    <LanuchWeapp
      v-if="isRenderMiniAppTag"
      :appid="jumpInfo.appid"
      :username="jumpInfo.username"
      :path="jumpInfo.path"
    ></LanuchWeapp>
  </div>
</template>

<script lang="ts">
import { PropType, defineComponent } from 'vue-demi';
import { LanuchWeapp } from '@tencent/wphk-components-launch-weapp';
import { getJumpType } from './business/index';
import { windowHelper } from '@tencent/ppd-base-libs';
import { MultiJumpInfo, MultiJumpType } from './types/index';

// 埋点 tag
const BI_TAG = 'multi-jump-container.jump';

export default defineComponent({
  name: 'MultiJumpContainer',
  props: {
    /** 图片地址 */
    imgUrl: String,
    /** 图片无障碍 */
    imgAlt: String,
    /** 跳转配置 */
    jumpInfo: Object as PropType<MultiJumpInfo>,
    /** 自定义事件额外数据 */
    extraData: {
      type: null,
      required: false,
    },
    /** biTag 用于bi 区分上报 */
    biTag: {
      type: String,
      required: true,
    },
  },
  components: { LanuchWeapp },
  setup(props, { emit }) {
    /** 跳转类型 */
    const jumpType = getJumpType(props.jumpInfo);
    /** 是否渲染小程序标签 */
    const isRenderMiniAppTag = jumpType === MultiJumpType.Mp;
    /** 上报信息 */
    const biContent = {
      tag: BI_TAG,
      ext: {
        ftype: jumpType,
        ftag: props.biTag,
      },
    };
    /** 处理点击 */
    function handleClick() {
      // 小程序会吃掉事件，所以这里不关心小程序的点击
      if (jumpType === MultiJumpType.H5 && props.jumpInfo?.jumpUrl) {
        windowHelper.redirect(props.jumpInfo.jumpUrl, 300);
      } else if (jumpType === MultiJumpType.Other) {
        emit('customEventClick', props.extraData);
      }
    }
    return {
      /** 是否是小程序广告 */
      isRenderMiniAppTag,
      /** 上报数据 */
      biContent,
      /** 处理点击 */
      handleClick,
    };
  },
});
</script>

<style lang="less" scoped>
@rem: 200rem;
.multi-jump-wrapper {
  .jump-img {
    width: 100%;
    object-fit: cover;
  }
}
</style>
